import { render } from "./ProductManageView.vue?vue&type=template&id=5041d4a7&scoped=true"
import script from "./ProductManageView.vue?vue&type=script&lang=js"
export * from "./ProductManageView.vue?vue&type=script&lang=js"

import "./ProductManageView.vue?vue&type=style&index=0&id=5041d4a7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5041d4a7"]])

export default __exports__